"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Card_1 = require("@dialogexe/cw-component-card/Card");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const moment = require("moment");
require("moment/locale/nn");
require("moment/locale/nb");
const bulletPoint = `\u2022`;
class CoverFlow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            previous: null,
            direction: null,
            selectedCategory: null
        };
        this.translateToNyNorsk = (value) => {
            switch (value) {
                case 'På kino nå':
                    return 'På kino no';
                case 'Kommende filmer':
                    return 'Komande filmar';
                default:
                    return value;
            }
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { title, imagePlaceholder, showMoreLinkTitle, showMoreLinkUrl } = this.props;
        const cards = this.getFilteredCards();
        if (cards.length === 0) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", { className: "CoverFlow" },
            React.createElement("h1", { className: "title" }, title),
            this.renderFilter(),
            React.createElement("div", { className: "card-container" },
                React.createElement("div", { className: "cards" }, cards.map((card, index) => (React.createElement("div", { key: index, className: `card-item ${this.getClass(index)}`, onTransitionEnd: this.onTransitionEnd.bind(this) },
                    React.createElement(Card_1.Card, { image: card.image || imagePlaceholder, title: card.title, subtitle: this.formatSubtitle(card.subtitle, card.type), link: card.link }))))),
                React.createElement("div", { className: "navigation" },
                    React.createElement("button", { className: "icon-button is-large", onClick: this.previous.bind(this) }, this.hasPrevious() ? (React.createElement("img", { src: icons_1.arrowLeftIcon, alt: "" })) : (React.createElement("img", { src: icons_1.arrowLeftInactiveIcon, alt: "" }))),
                    React.createElement("button", { className: "icon-button is-large", onClick: this.next.bind(this) }, this.hasNext() ? (React.createElement("img", { src: icons_1.arrowRightIcon, alt: "" })) : (React.createElement("img", { src: icons_1.arrowRightInactiveIcon, alt: "" }))))),
            showMoreLinkTitle && showMoreLinkUrl && (React.createElement("div", { className: "level is-flex-end" },
                React.createElement("a", { href: showMoreLinkUrl, className: "show-more" }, showMoreLinkTitle)))));
    }
    renderFilter() {
        const selectedCategory = this.resolveSelectedCategory();
        const { displayType, preferredLanguage } = this.props;
        let categories = this.getDistinctCategories();
        if (displayType !== 'movies' && categories.length <= 1) {
            return (React.createElement("div", null));
        }
        return (React.createElement("nav", { className: "filter" },
            React.createElement("div", { className: "tabs is-hidden-mobile" },
                displayType !== 'movies' && (React.createElement("a", { href: "#", className: `tab ${selectedCategory === null ? 'is-active' : ''}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(null); } }, "Alle")),
                categories.map((category, i) => (React.createElement("a", { key: i, href: "#", className: `tab ${category === selectedCategory ? 'is-active' : 'is-not-active'}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(category); } }, preferredLanguage === 'nn' ? this.translateToNyNorsk(category) : category)))),
            React.createElement("div", { className: "is-hidden-tablet" },
                React.createElement("div", { className: "input" },
                    React.createElement("select", { className: "", onChange: (e) => {
                            e.target.value === '' ?
                                this.setState({ selectedCategory: null }) :
                                this.setState({ selectedCategory: e.target.value });
                        } }, categories.map((category, i) => (React.createElement("option", { value: category, key: i }, preferredLanguage === 'nn' ? this.translateToNyNorsk(category) : category)))),
                    React.createElement("i", { className: "" },
                        React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" }))))));
    }
    onCategorySelect(category) {
        this.setState({
            current: 0,
            previous: null,
            direction: null,
            selectedCategory: category
        });
    }
    formatSubtitle(subtitle, type) {
        const { displayType } = this.props;
        if (!moment(subtitle).isValid()) {
            return subtitle;
        }
        if (displayType === 'movies' && type === 'movie_coming') {
            return 'Premiere ' + moment(subtitle).format('ll');
        }
        if (displayType === 'movies' && type === 'movie') {
            return '';
        }
        const day = this.capitalizeFirstLetter(moment(subtitle).format("dddd"));
        return `${day} ${moment(subtitle).format("DD. MMMM")} ${bulletPoint} ${moment(subtitle).format("HH:mm")}`;
    }
    capitalizeFirstLetter(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    previous() {
        if (this.state.direction) {
            return;
        }
        if (this.state.current === 0) {
            return;
        }
        this.setState({
            current: this.state.current - 1,
            previous: this.state.current - 1,
            direction: 'previous'
        });
    }
    next() {
        if (this.state.direction) {
            return;
        }
        if (this.state.current >= this.getFilteredCards().length - 4) {
            return;
        }
        this.setState({
            current: this.state.current + 1,
            previous: this.state.current,
            direction: 'next'
        });
    }
    getClass(index) {
        const direction = this.state.direction;
        const current = this.state.current;
        if (direction === null) {
            if (index >= current && index < current + 4) {
                return '';
            }
            return 'is-inactive';
        }
        const previous = this.state.previous;
        if (index === previous) {
            return direction === 'next' ? 'leaving-left' : 'entering-left';
        }
        if (index === previous + 4) {
            return direction === 'next' ? 'entering-right' : 'leaving-right';
        }
        if (index > previous && index < previous + 4) {
            return direction === 'next' ? 'moving-left' : 'moving-right';
        }
        return 'is-inactive';
    }
    getFilteredCards() {
        const { cards } = this.props;
        const selectedCategory = this.resolveSelectedCategory();
        const filtered = cards
            .filter((card) => (selectedCategory === null || card.category === selectedCategory));
        const uniqueCards = this.getUniqueCardsByLink(filtered);
        return uniqueCards.sort((c1, c2) => (moment(c1.date).unix() - moment(c2.date).unix()));
    }
    getUniqueCardsByLink(cards) {
        return cards.filter((v, i, a) => a.findIndex(t => (t.link === v.link)) === i);
    }
    getDistinctCategories(returnMap = false) {
        const { cards } = this.props;
        let categories = {};
        if (returnMap) {
            cards.forEach(card => {
                categories[card.type] = card.category;
            });
            return categories;
        }
        cards.forEach(card => {
            categories[card.category] = '';
        });
        return Object.keys(categories);
    }
    hasNext() {
        return this.state.current < this.getFilteredCards().length - 4;
    }
    hasPrevious() {
        return this.state.current > 0;
    }
    onTransitionEnd() {
        this.setState({
            previous: null,
            direction: null
        });
    }
    resolveSelectedCategory() {
        const { displayType } = this.props;
        const { selectedCategory } = this.state;
        const categories = this.getDistinctCategories(true);
        if (displayType !== 'movies' || selectedCategory !== null) {
            return this.state.selectedCategory;
        }
        let preselectMoviesCat = '';
        if (typeof categories['movie'] !== 'undefined') {
            preselectMoviesCat = categories['movie'];
        }
        else if (typeof categories['movie_coming'] !== 'undefined') {
            preselectMoviesCat = categories['movie_coming'];
        }
        return preselectMoviesCat;
    }
}
exports.CoverFlow = CoverFlow;
exports.default = CoverFlow;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-cover-flow/CoverFlow.tsx